export const PATH = {
  HOME: "/procedure/recall-tool",
};
